import { Component, Input } from '@angular/core';
// Import como namespace, no con nombres sueltos: los métodos públicos de este componente se llaman
// igual que las funciones puras del helper (misma firma en la plantilla, más legible que renombrar
// los métodos). Con un import nombrado, "return maxOf(...)" y "return this.maxOf(...)" compilan los
// dos, y anteponer "this." por hábito al tocar este fichero se convierte en recursión infinita
// silenciosa. "metrics.maxOf(...)" no se puede confundir con "this.maxOf(...)".
import * as metrics from '../_helpers/platform-health-metrics';
import { AppInsightsBlock, MetricSeries, PlatformBlock } from '../_types/platform-health';

/// Los siete indicadores de API: se pintan igual en "Visión global" y en la pestaña "API", así que
/// viven en un único componente para no copiar la fila entre las dos plantillas.
@Component({
    selector: 'app-platform-health-api-indicators',
    templateUrl: './platform-health-api-indicators.component.html',
    styleUrls: ['./platform-health-api-indicators.component.scss'],
    standalone: false
})
export class PlatformHealthApiIndicatorsComponent {
    @Input() public platform: PlatformBlock | null = null;
    @Input() public appInsights: AppInsightsBlock | null = null;

    public maxOf(series: MetricSeries[] | undefined, name: string): number | null {
        return metrics.maxOf(series, name);
    }

    public sumOf(series: MetricSeries[] | undefined, name: string): number | null {
        return metrics.sumOf(series, name);
    }

    public minOf(series: MetricSeries[] | undefined, name: string): number | null {
        return metrics.minOf(series, name);
    }

    public peakRequestsPerSecond(): number | null {
        return metrics.peakRequestsPerSecond(this.platform);
    }

    public errorRatePercent(): number | null {
        return metrics.errorRatePercent(this.platform);
    }

    public worstP95Ms(): number | null {
        return metrics.worstP95Ms(this.appInsights);
    }
}
